/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { ControlDefinition } from "@anvilor/ngx-rui";
import { LegacyRuiControl } from "@anvilor/ngx-rui";
import { RuiStore } from "@anvilor/ngx-rui";
import { Observable } from "rxjs";

export const CONTROL_ATTENTION_BANNER = "anvilor_forms:attention_banner";

export interface AttentionBannerControlDefinition extends ControlDefinition {
  control: typeof CONTROL_ATTENTION_BANNER;

  color?: string;
  label: string;
  height?: string;
  closeable?: boolean;
}

/* eslint-disable-next-line max-len */
export class AttentionBannerControl extends LegacyRuiControl<AttentionBannerControlDefinition> {
  color$: Observable<string>;
  label$: Observable<string>;
  height$: Observable<string | null>;
  closeable$: Observable<boolean>;

  constructor(store: RuiStore, id: string) {
    super(store, id);

    this.color$ = this.evaluatedSelect((d) => d.color ?? "#FFCA28");
    this.label$ = this.evaluatedSelect((d) => d.label);
    this.height$ = this.evaluatedSelect((d) => d.height ?? null);
    this.closeable$ = this.evaluatedSelect((d) => d.closeable ?? true);
  }
}
